module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAARklEQVQ4y83UwQkAIAxD0UAH6Eiu3pEcQIhQEN3An9u7FUIqP5n6rNLJQMiVNkG5+igh1GWFEVrCSGGMujEboe8rvuL8ug3RCfJ1HLc1uAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xM1QxNToyNzowOCswOTowMBCC6ssAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjIrMDk6MDA/qCjNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_02275_100x100.png
// module id = jvwS
// module chunks = 0